import React from 'react';
import './OrderProgressBar.scss';

const OrderProgressBar = ({ barStep }) => {
  const steps = [
    {
      barStep: 1,
      label: '选择套餐',
      path: '/barStep/1',
      header: '创建新订单',
      icon: <i className="bi bi-1-circle"></i>,
    },
    {
      barStep: 2,
      label: '订单信息',
      path: '/barStep/2',
      header: '创建新订单',
      icon: <i className="bi bi-2-circle"></i>,
    },
    {
      barStep: 3,
      label: '素材上传',
      path: '/barStep/3',
      header: '素材上传',
      icon: <i className="bi bi-3-circle"></i>,
    },
    {
      barStep: 4,
      label: '文案确认',
      path: '/barStep/4',
      header: '文案确认',
      icon: <i className="bi bi-4-circle"></i>,
    },
  ];

  const currentStep = steps.filter((s) => s.barStep === barStep);

  return (
    <>
      <div className="progress-bar">
        <h1>{currentStep[0]?.header}</h1>
        <div className="selection-bar">
          {steps.map((s, index) => (
            <React.Fragment key={s.barStep}>
              <div
                className={`barStep-item ${
                  barStep === s.barStep ? 'active' : ''
                }`}
              >
                <div className="barStep-icon">
                  {barStep === s.barStep ? (
                    <i className="bi bi-check-circle"></i>
                  ) : (
                    s.icon
                  )}
                </div>
                <div className="barStep-label">{s.label}</div>
              </div>
              {index < steps.length - 1 && <div className="barStep-line"></div>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default OrderProgressBar;
